
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { MobileRaiseProjection } from "@/store/mobile-raise-templates/types";
import Title from "./Title.vue";
import api from "@/services/api.service";
import mobileApi from "@/services/api.mobile.service";
import UploadFileButton from "@/components/mobile/dispatch/UploadFileButton.vue";
import { UserPermissions } from "@/store/types";

const Mobile = namespace("mobile");

@Component({
	components: {
		"raise-title": Title,
		"upload-file-button": UploadFileButton
	}
})
export default class ManualRaiseDetails extends Vue {
	@Prop() raise: MobileRaiseProjection;
	@Prop() eventId: number;
	@Prop() eventLocation: string;
	@Mobile.Getter getGuardId: number;
	@Mobile.Action addNoteForEvent: any;
	@Mobile.Action activateDispatchRequest: (dispatchRequestId: number) => Promise<void>;
	@Mobile.Action loadDispatchRequestsForGuard: any;
	@Getter getFeature: (featureName: string[]) => boolean;
	@Getter getPermissions: UserPermissions;
	@Getter getUserName: string;

	private notes: string = "";
	private cancelUpload: boolean = false;
	private isUploading = false;

	private onIsUploading({ state }: { state: boolean }) {
		this.isUploading = state;
	}

	private onUploadSuccess() {
		this.isUploading = false;
	}

	private async onComplete() {
		await this.addNote();
		this.$emit("close");
	}

	private async onDispatchSelf() {
		await this.addNote();

		const { data: eventDetails } = await api.loadEventDetails(this.eventId);

		const { data: dispatchQueueId }: { data: number } = await mobileApi.addDispatchRequest(
			this.getGuardId,
			null,
			this.eventId,
			this.getUserName,
			"Dispatch to area and investigate",
			eventDetails.latLong,
			eventDetails.siteTitle
		);

		await this.loadDispatchRequestsForGuard(this.getGuardId);

		await this.activateDispatchRequest(dispatchQueueId);

		this.$emit("selfDispatch");
	}

	private async addNote() {
		if (this.notes.length > 0) {
			await this.addNoteForEvent({
				guardNote: this.notes,
				eventId: this.eventId
			});
		}
	}

	private get isDispatchSelfEnabled() {
		return (
			this.getFeature(["Mobile", "Dispatch"]) &&
			this.getPermissions.canMobileDispatch &&
			this.getPermissions.canClaimFromMobileRaise &&
			this.getPermissions.canViewEvents &&
			this.getGuardId !== null
		);
	}
}
